var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm4.746-22.877h2.342l-5.116 5.847 6.018 7.956h-4.712l-3.691-4.825-4.222 4.825H9.022l5.471-6.253-5.773-7.55h4.832l3.336 4.411 3.858-4.411zm-.822 12.402h1.298l-8.375-11.074h-1.393l8.47 11.074z",
    fill: "#fff"
  })));
}
export default SvgXIcon;